var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    viewBox: "0 14.98 315.78 285.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fill: "#8d8d8c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#8d8d8c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M315.585,177.814L288.037,14.979H27.62L0,178.347l0.114,0.022v122.428h315.662V177.819h-0.19    V177.814z M38.884,28.316h237.883l25.292,149.498H202.045v6.647l0,0c0,24.209-19.711,43.915-43.92,43.915    s-43.893-19.706-43.893-43.915h-0.163v-6.647H13.614L38.884,28.316z",
    id: "svg_3",
    fill: "#8d8d8c",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.f3e5244b27d7f7bef77fd70ac0a11836.svg";
export { ForwardRef as ReactComponent };